import { Pipe, PipeTransform } from '@angular/core';
import {
  EmployeeCheckTypeEnum,
  EmployeeCheckTypeInfo,
} from '@qaroni-app/employee/types/employee-checks-type.enum';

@Pipe({
  name: 'checksTypeName',
  standalone: false,
})
export class ChecksTypeNamePipe implements PipeTransform {
  transform(value: EmployeeCheckTypeEnum): string {
    if (
      value &&
      Object.prototype.hasOwnProperty.call(EmployeeCheckTypeInfo, value)
    ) {
      return EmployeeCheckTypeInfo[value].name;
    }

    return value;
  }
}
